// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1YXZy","content":"LayoutSettings_content__AxFa6"};